// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1_iHd","title":"Header_title__1R5CG","left":"Header_left__1qnCW","clinicName":"Header_clinicName__RWKA0"};